{
  "ramps": {
    "stalk": ["#5A3414", "#8A5A2A", "#B88A50"],
    "peach": ["#C8385A", "#F46A84", "#FFA08C", "#FFD2A6"],
    "banana": ["#B88A00", "#FFD21E", "#FFEA6A"],
    "seed": ["#C8A020", "#FFE070", "#FFF6C0"],
    "orange": ["#B85200", "#FF9418", "#FFC04A"],
    "rind": ["#C8E0B0", "#F2FAE4", "#FFFFFF"],
    "pineapple": ["#8A5200", "#D89420", "#FFCA3A", "#FFE890"],
    "persimmon": ["#9A2A00", "#F05A14", "#FF8C3A"],
    "grape": ["#2E0A52", "#6A28B0", "#9A5AE6", "#D2B0FF"],
    "eggplant": ["#2A0848", "#5C1C96", "#8A46CC", "#C89AF4"],
    "egg": ["#C8BCA0", "#F6F0E0", "#FFFFFF"],
    "turnip": ["#6A0A5A", "#B83A9A", "#E88AC8"],
    "onion": ["#8A4A0A", "#C88428", "#EEBC5A", "#FFE4A0"],
    "carrot": ["#B04000", "#E8600C", "#FF7A14", "#FFA850"],
    "chestnut": ["#3A1808", "#74381A", "#A85E30", "#E8C08A"],
    "beet": ["#4A0024", "#A0104E", "#D83A7C"],
    "corn": ["#C89000", "#FFD21E", "#FFEE80"],
    "husk": ["#3A8A2A", "#78C84A", "#B8EC7A"],
    "sponge": ["#B87A1E", "#F4C85A", "#FFE8A0"],
    "cream": ["#D8D0C4", "#FFF8EC", "#FFFFFF"],
    "icing": ["#B8306E", "#FF70AE", "#FFB8D8"],
    "dough": ["#8A4A14", "#D08A3E", "#F4BE70"],
    "waffle": ["#8A4A14", "#D08A3A", "#F4BE6A"],
    "iceBlue": ["#1A5AC0", "#40A0FF", "#A0D8FF"],
    "iceWhite": ["#B0B8D0", "#EEF2FA", "#FFFFFF"],
    "iceLemon": ["#B8A000", "#FFE640", "#FFF6A8"],
    "glass": ["#4A8AA8", "#9ED4EA", "#E0F6FF"],
    "creamGrape": ["#5A2A96", "#9A5ADC", "#C8A0F4"],
    "creamPink": ["#C04A80", "#FF8ABE", "#FFC8E0"],
    "wood": ["#7A4A1E", "#C8965A", "#EED0A0"],
    "icepop": ["#9A0A32", "#F0284E", "#FF8A9E"],
    "cup": ["#7A1A30", "#D83A5E", "#FFB0C0"],
    "choc": ["#3A1608", "#6E3418", "#A0603A"],
    "caramel": ["#5A2000", "#9A4A10", "#D07A30"],
    "custard": ["#C89A20", "#FFD85A", "#FFF0A8"],
    "rice": ["#C0B8AC", "#F4F0E8", "#FFFFFF"],
    "tuna": ["#7A0A20", "#E0304A", "#FF8A96"],
    "shrimp": ["#C83A10", "#FF7A3A", "#FFE4D0"],
    "nori": ["#0A1A10", "#1E3A24", "#3A5A40"],
    "bun": ["#9A4A10", "#E0902E", "#FFC266"],
    "cheese": ["#C89000", "#FFC81E", "#FFE680"],
    "fries": ["#C88A10", "#FFD444", "#FFF0A0"],
    "carton": ["#8A0A1A", "#E62432", "#FF6A6A"],
    "bowl": ["#7A0A10", "#D8242A", "#FF6A5A"],
    "noodle": ["#C89A20", "#F2CC50", "#FFE890"],
    "broth": ["#7A3A10", "#C07030", "#E8A060"],
    "beer": ["#A85A00", "#F4A416", "#FFD45A"],
    "drink": ["#A8B870", "#E0F0B0", "#F8FFE0"],
    "olive": ["#3A5A0A", "#7AA028", "#B8DC60"],
    "fried": ["#7A3A08", "#D07A20", "#F4B050"],
    "chackn": ["#B89000", "#FFD820", "#FFF07A"],
    "beak": ["#B04A00", "#FF8A1E", "#FFC060"],
    "gemPurple": ["#3A0A6A", "#7A28D0", "#B070FF", "#E8D0FF"],
    "gemRed": ["#6A0016", "#D4102E", "#FF5A6A", "#FFD0D8"],
    "gemGreen": ["#0A4A1A", "#12A03C", "#5AE07E", "#D0FFD8"],
    "diamondYellow": ["#8A7000", "#F2D21E", "#FFF27A", "#FFFFE8"],
    "diamondGreen": ["#0A5A2A", "#1AB24C", "#7AF09A", "#E8FFF0"],
    "diamondPurple": ["#4A0A8A", "#8A3AF0", "#C89AFF", "#F4E8FF"],
    "diamondBlue": ["#0A2A8A", "#2A6AF0", "#8AC0FF", "#E8F4FF"],
    "velvetRed": ["#6A0014", "#C0142E", "#F04A5A"],
    "velvetGreen": ["#0A4A1A", "#1A9A3A", "#5AD06A"],
    "pearl": ["#C8C0D0", "#F4F0FA", "#FFFFFF"],
    "citrine": ["#8A6200", "#E8B820", "#FFE45A", "#FFFBD0"]
  }
}
